/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Etaf_Link_InvalidInputs */

const en_error_etaf_link_invalid = /** @type {(inputs: Error_Etaf_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link is not valid any more.`)
};

/**
* | output |
* | --- |
* | "This link is not valid any more." |
*
* @param {Error_Etaf_Link_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_etaf_link_invalid = /** @type {((inputs?: Error_Etaf_Link_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Etaf_Link_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_etaf_link_invalid(inputs)
});